export enum BidsFilter {
  All = 'all',
  My = 'my',
}
